// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"dd8e710e","752":"d6ab3fef"}[chunkId] + ".chunk.css";
};